import React, { useEffect, useRef, useState } from "react";
import { Bars } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { offerUserList } from "../../Services/ApiServices";
import { IMG_URL } from "../../Services/Api";
import back from "../../Assets/Image/admin/back.png";

function OfferUsers() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const { id } = useParams();

  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [offersData, setOffersData] = useState([]);

  const handleCategoryList = () => {
    setLoader(true);
    let obj = {
      page_no: pageNo,
      offer_id: id,
    };
    offerUserList(obj)
      .then((res) => {
        const data = res.data.data;
        setOffersData(data.reword_histories);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleCategoryList();
  }, []);

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex items-center cursor-pointer mb-4">
        <img
          src={back}
          onClick={() => {
            navigate("/offers");
          }}
          className="w-4"
          alt=""
        />
        <p
          onClick={() => {
            navigate("/offers");
          }}
          className="text-base font-medium ms-3 p-0"
        >
          Go back
        </p>
      </div>
      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {offersData.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <div className="col-span-12">
                <div
                  className="w-full lg:overflow-hidden overflow-auto"
                  onMouseDown={startDragging}
                  onMouseLeave={stopDragging}
                  onMouseUp={stopDragging}
                  onMouseMove={onDragging}
                  ref={scrollRef}
                >
                  <table className="w-full border-separate border-spacing-y-3">
                    <thead>
                      <tr className="bg-white">
                        <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>USER ID</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>USER NAME</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>EMAIL</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>USER REWARD POINT</h4>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {offersData.map((item, index) => (
                        <tr key={index} className="font-medium bg-white">
                          <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              {item.user.id || "-"}
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap flex items-center gap-2">
                              <div>
                                <img
                                  src={IMG_URL + item.user.profile_image}
                                  className="w-[45px] h-[45px] rounded-full"
                                  alt=""
                                />
                              </div>
                              <p className="text-base truncate w-[250px]">
                                {item.user.firstname || "-"}{" "}
                                {item.user.lastname}
                              </p>
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[250px]">
                                {item.user.email || "-"}
                              </p>
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[250px]">
                                {item.user.reward_point || "-"}
                              </p>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default OfferUsers;
